import { browser } from '$app/environment';
import type { SupabaseClient } from '@supabase/supabase-js';
import { get, writable } from 'svelte/store';
import { invalidate } from '$app/navigation';
import { getContext } from 'svelte';
import type { User } from '@riva-mono/common';

export const getUser = () => {
	if (!browser) return null;
	const userStore: UserStore = getContext('user');
	return get(userStore);
};

export const createUserStore = (user: User) => {
	const { set, update, subscribe } = writable(user);

	const logout = async (supabase: SupabaseClient) => {
		set({ loading: true });
		await supabase.auth.signOut();
		invalidate('supabase:auth');
		window.location.reload();
	};

	const setUser = (data: User | null) => {
		if (!browser) return;
		window.sessionStorage.setItem('user', JSON.stringify(data));
		if (data) {
			set(data);
		} else set({ loading: false });
	};

	return { set, update, subscribe, logout, setUser };
};

export type UserStore = ReturnType<typeof createUserStore>;
